var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import React from 'react';
import { observe } from 'mobx';
import { observer } from 'mobx-react';
import * as monaco from 'monaco-editor';
import cx from 'classnames';
import ReactModal from 'react-modal';
import debounce from 'lodash.debounce';
// import Splitter from '@leiko/m-react-splitters';
// import '@leiko/m-react-splitters/lib/splitters.css';
import SplitPane from 'react-split-pane';
import { version } from '../../package.json';
import greycatLogo from './assets/images/greycat-head.svg';
import Sidebar from './components/sidebar/Sidebar';
import EditorPane from './components/editor-pane/EditorPane';
import ContextPane from './components/context-pane/ContextPane';
import ConsolePane from './components/console-pane/ConsolePane';
import Settings from './components/settings/Settings';
import FAIcon from './components/icons/FAIcon';
// tslint:disable-next-line:no-var-requires
const gcDeclaration = require('raw-loader!@greycat/core/dist/typings/greycat-core.d.ts');
monaco.languages.typescript.typescriptDefaults.addExtraLib(gcDeclaration, 'greycat-core.d.ts');
monaco.languages.typescript.typescriptDefaults.addExtraLib(`
import * as g from '@greycat/core';
export = g;
export as namespace g;
`, 'greycat-core-ns.d.ts');
monaco.languages.typescript.typescriptDefaults.addExtraLib(`
declare namespace studio {
  const console: Console;
}`);
import styles from './studio.module.scss';
let Studio = class Studio extends React.Component {
    constructor(props) {
        super(props);
        this._editor = null;
        this._onWindowResize = debounce(() => {
            if (this._editor) {
                this._editor.layout();
            }
        }, 200);
        this.onEditorSplitterDragFinished = this.onEditorSplitterDragFinished.bind(this);
        this.onEditorDidMount = this.onEditorDidMount.bind(this);
        this.selectWorkspaceRootDir = this.selectWorkspaceRootDir.bind(this);
    }
    resetSplitterDefault(key) {
        return () => {
            this.props.store.layout.reset(key);
            if (this._editor) {
                this._editor.layout();
            }
        };
    }
    onEditorSplitterDragFinished(key) {
        return (primaryPaneWidth) => {
            this.props.store.layout[key] = primaryPaneWidth;
            if (this._editor) {
                this._editor.layout();
            }
        };
    }
    onEditorDidMount(e) {
        this._editor = e;
        const updateEditorLayout = () => {
            setTimeout(() => {
                if (this._editor) {
                    this._editor.layout();
                }
            });
        };
        observe(this.props.store.layout, updateEditorLayout);
    }
    selectWorkspaceRootDir() {
        if ('true' === process.env.TARGET_ELECTRON) {
            const { ipcRenderer } = require('electron');
            const { WS_SELECT_DIR } = require('../common/commands');
            ipcRenderer.send(WS_SELECT_DIR, this.props.store.sidebar.editorWorkspaces.rootDir);
            ipcRenderer.on(WS_SELECT_DIR, (_event, dir) => {
                this.props.store.sidebar.editorWorkspaces.selectedDir = dir;
            });
        }
    }
    componentDidMount() {
        window.addEventListener('resize', this._onWindowResize);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this._onWindowResize);
    }
    render() {
        const { store } = this.props;
        let workspaceModal;
        if ('true' === process.env.TARGET_ELECTRON) {
            workspaceModal = (React.createElement(ReactModal, { isOpen: store.sidebar.editorWorkspaces.isSelectDirOpen, overlayClassName: cx(styles.modalOverlay, { night: store.settings.nightMode }), shouldCloseOnEsc: true, shouldCloseOnOverlayClick: true, onRequestClose: store.sidebar.editorWorkspaces.hideSelectDir, style: {
                    content: {
                        zIndex: 10001,
                        top: '50%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        marginRight: '-50%',
                        transform: 'translate(-50%, -50%)',
                    },
                }, ariaHideApp: false },
                React.createElement("div", { className: styles.workspaceModal },
                    React.createElement("h2", null, "Select a workspace:"),
                    React.createElement("p", null,
                        "Select a directory to store your workspaces.",
                        React.createElement("br", null),
                        React.createElement("em", { className: "muted" }, "Be sure to have right-access to this directory")),
                    React.createElement("div", { style: { paddingBottom: 10 } },
                        React.createElement("div", null,
                            React.createElement("strong", { style: { display: 'inline-block', minWidth: '70px' } }, "Current: "),
                            React.createElement("span", { className: "muted" }, store.sidebar.editorWorkspaces.rootDir)),
                        store.sidebar.editorWorkspaces.selectedDir && (React.createElement("div", { style: { paddingTop: 5 } },
                            React.createElement("strong", { style: { display: 'inline-block', minWidth: '70px' } }, "Selected: "),
                            React.createElement("span", { className: "muted" }, store.sidebar.editorWorkspaces.selectedDir)))),
                    React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between' } },
                        React.createElement("button", { onClick: this.selectWorkspaceRootDir }, "Select"),
                        React.createElement("button", { onClick: store.sidebar.editorWorkspaces.update }, "Ok")))));
        }
        return (React.createElement("div", { className: styles.studio },
            React.createElement("div", { className: styles.studioHeader },
                React.createElement("div", { className: styles.header },
                    React.createElement("div", { className: styles.greycatLogo, dangerouslySetInnerHTML: { __html: greycatLogo } }),
                    React.createElement("div", { className: styles.headerTitle },
                        React.createElement("h1", null, "GreyCat Studio"),
                        React.createElement("span", { className: "muted", style: { fontFamily: 'monospace' } },
                            "v",
                            version))),
                React.createElement("div", { className: styles.actions },
                    React.createElement("span", { className: styles.action, onClick: store.settings.open, title: "Settings" },
                        React.createElement(FAIcon, { className: "fa fa-cog" })))),
            React.createElement("div", { className: styles.studioBody },
                React.createElement(SplitPane, { split: "vertical", className: styles.mainSplitter, size: store.layout.sidebarPanel, maxSize: "calc(100% - 50px)", minSize: 0, onResizerDoubleClick: this.resetSplitterDefault('sidebarPanel'), onDragFinished: this.onEditorSplitterDragFinished('sidebarPanel') },
                    React.createElement(Sidebar, { store: store }),
                    React.createElement(SplitPane, { split: "horizontal", size: store.layout.editorAndCtxPanel, maxSize: "calc(100% - 38px)", minSize: 0, pane2Style: { overflow: 'hidden' }, onResizerDoubleClick: this.resetSplitterDefault('editorAndCtxPanel'), onDragFinished: this.onEditorSplitterDragFinished('editorAndCtxPanel') },
                        React.createElement(SplitPane, { split: "vertical", size: store.layout.editorPanel, maxSize: "calc(100% - 8px)", minSize: 0, pane2Style: { overflow: 'hidden' }, onResizerDoubleClick: this.resetSplitterDefault('editorPanel'), onDragFinished: this.onEditorSplitterDragFinished('editorPanel') },
                            React.createElement(EditorPane, { store: store, editorDidMount: this.onEditorDidMount }),
                            React.createElement(ContextPane, { store: store })),
                        React.createElement(ConsolePane, { store: store })))),
            React.createElement(ReactModal, { isOpen: store.settings.isOpen, shouldCloseOnEsc: true, shouldCloseOnOverlayClick: true, onRequestClose: store.settings.close, overlayClassName: cx(styles.modalOverlay, { night: store.settings.nightMode }), style: { content: { zIndex: 10000 } }, ariaHideApp: false },
                React.createElement(Settings, { store: store.settings })),
            workspaceModal));
    }
};
Studio = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], Studio);
export default Studio;
